import React, { useEffect, useState } from "react";
import { updatePreferenceData } from "../../../../services/CommonService";
import { toast } from "react-toastify";
import Utils from "../../../../utils";

function Theme(props) {
  //   const [themeColor, setThemeColor] = useState("");
  //   const [loading, setLoading] = useState(false);

  //   useEffect(() => {
  //     if (props.themeList && props.themeList.length > 0) {
  //       // Check if any theme is selected
  //       let index = props.themeList.findIndex((x) => x.selected === true);
  //       if (index > -1) {
  //         // If a theme is selected, use it
  //         setThemeColor(props.themeList[index]["class"]);
  //       } else {
  //         // If no theme is selected (new user), set the default theme (e.g., first theme)
  //         const defaultTheme = props.themeList[0]["class"]; // Default to first theme
  //         setThemeColor(defaultTheme);

  //         // Optionally, save the default theme to the backend for the new user
  //         let updateList = [{ slug: "default_color", value: defaultTheme }];
  //         updatePreferenceData({ list: updateList })
  //           .then((response) => {
  //             let list = [...props.themeList];
  //             for (let i = 0; i < list.length; i++) {
  //               list[i]["selected"] = list[i]["class"] === defaultTheme;
  //             }
  //             props.setThemeList(list);
  //             Utils.updateTheme(defaultTheme);
  //           })
  //           .catch((err) => {
  //             toast.error(Utils.getErrorMessage(err));
  //           });
  //       }
  //     }
  //   }, [props?.themeList]);

  //   const handleClick = (e) => {
  //     e.preventDefault();
  //     props.setLoading(true);

  //     let updateList = [{ slug: "default_color", value: themeColor }];

  //     updatePreferenceData({ list: updateList })
  //       .then((response) => {
  //         props.setLoading(false);
  //         let list = [...props.themeList];
  //         for (let i = 0; i < list.length; i++) {
  //           list[i]["selected"] = list[i]["class"] === themeColor;
  //         }
  //         props.setThemeList(list);
  //         Utils.updateTheme(themeColor);
  //         toast.success(response.data.message);
  //       })
  //       .catch((err) => {
  //         props.setLoading(false);
  //         toast.error(Utils.getErrorMessage(err));
  //       });
  //   };

  return (
    <div>

    </div>

    // <>

    //       {loading && (
    //         <div className="page-loading">
    //           <img src="/images/loader.gif" alt="loader" />
    //         </div>
    //       )}
    //       <div
    //         className="tab-pane py-4 px-3"
    //         id="nav-theme"
    //         role="tabpanel"
    //         aria-labelledby="nav-theme-tab"
    //       >
    //         <h2 className="sub_main_title">Change Client Portal Theme.</h2>
    //         <div className="row">
    //           <div className="col-lg-12">
    //             {/* <label className="my-4">Choose colour / Enter colour code</label> */}
    //             <label className="my-4">Choose colour</label>
    //           </div>
    //           <div className="col-lg-2">
    //             <select
    //               className="form-select"
    //               value={themeColor}
    //               onChange={(e) => setThemeColor(e.target.value)}
    //             >
    //               {props?.themeList &&
    //                 props.themeList.map((item, index) => (
    //                   <option key={index} value={item.class}>
    //                     {item.name}
    //                   </option>
    //                 ))}
    //             </select>
    //           </div>
    //           <div className="mt-4 rounded-pill">
    //             <button
    //               type="submit"
    //               onClick={handleClick}
    //               className="btn btn-primary"
    //             >
    //               Save
    //             </button>
    //           </div >
    //         </div>
    //       </div>
    // </>
  );
}

export default Theme;